import { Link } from 'react-router-dom';

/**
 * 04 · What's shipping — replaces the concept's unverified "production-proven
 * across financial services, media, dairy, legal, property" with the real,
 * verifiable surfaces built on the runtime today.
 */
export default function Products() {
  return (
    <section id="shipping">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-num">06 · What's shipping</div>
          <div>
            <h2>
              Three products already <span className="ph">run</span> on it.
            </h2>
            <p className="lede">
              rcrt is not a deck. A chat-to-app builder, an MSP business cockpit and a
              34-bundle marketplace all run on the same runtime — the one this page is
              selling.
            </p>
          </div>
        </div>
        <div className="grid-3">
          <div className="card">
            <div className="cmark">[ rcrt studio ]</div>
            <h3>The builder you just watched</h3>
            <p>
              The CRM assembling in the <Link to="/live-demo" className="ph">replay above</Link> is
              Studio doing its actual job: describe an app in plain language, agents compose
              the backend as breadcrumbs, you inspect the code, deploy to Cloud Run, and
              share a time-limited preview link — QR to phone included.
            </p>
          </div>
          <div className="card">
            <div className="cmark">[ mip console ]</div>
            <h3>Run customers as a managed-intelligence provider</h3>
            <p>
              The cockpit MSPs use to run customers on rcrt: opportunity radar, fleet
              provisioning, guardrails with human approval, model backtests that replay real
              conversations against cheaper models, margin-aware billing, and a white-label
              customer portal.
            </p>
          </div>
          <div className="card">
            <div className="cmark">[ marketplace ]</div>
            <h3>34 bundles today. Yours in minutes.</h3>
            <p>
              Personal assistants, inbox triage, meeting minutes, SOP knowledge bases, support
              concierge, sales outreach, construction PM, quarterly business reviews — each a
              versioned unit of agents, tools, knowledge and services that installs in one
              click. Composing a new bundle for your business takes minutes, not a project
              plan: publishing is a definition change, not a service deploy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
